"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetType = exports.WidgetStatus = exports.QuestionImageLayoutType = exports.QuestionLayoutType = void 0;
var QuestionLayoutType;
exports.QuestionLayoutType = QuestionLayoutType;

(function (QuestionLayoutType) {
  QuestionLayoutType["BulletList"] = "bullet-list";
  QuestionLayoutType["NumberedList"] = "numbered-list";
})(QuestionLayoutType || (exports.QuestionLayoutType = QuestionLayoutType = {}));

var QuestionImageLayoutType;
exports.QuestionImageLayoutType = QuestionImageLayoutType;

(function (QuestionImageLayoutType) {
  QuestionImageLayoutType["NoImage"] = "no-image";
  QuestionImageLayoutType["HeaderImage"] = "header-image";
  QuestionImageLayoutType["BackgroundImage"] = "background-image";
  QuestionImageLayoutType["BackgroundColor"] = "background-color";
})(QuestionImageLayoutType || (exports.QuestionImageLayoutType = QuestionImageLayoutType = {}));

var WidgetStatus;
exports.WidgetStatus = WidgetStatus;

(function (WidgetStatus) {
  WidgetStatus["Draft"] = "draft";
  WidgetStatus["Published"] = "published";
})(WidgetStatus || (exports.WidgetStatus = WidgetStatus = {}));

var WidgetType;
exports.WidgetType = WidgetType;

(function (WidgetType) {
  WidgetType["Quiz"] = "quiz";
  WidgetType["Poll"] = "poll";
  WidgetType["Empty"] = "";
})(WidgetType || (exports.WidgetType = WidgetType = {}));